var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.526,
    height: 26.928,
    viewBox: "0 0 29.526 26.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17123",
    "data-name": "Group 17123",
    transform: "translate(-253.846 -295.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985",
    transform: "translate(265.209 305.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M523.489,543.151s2.608-2.368,3.2-2.9c1.136-1.014-.19-2.1-.983-1.914a17.128,17.128,0,0,0-3.76,1.857s-5.088,1.494-6.819,4.164c-2.476,3.82,2.741,6.96,2.741,6.96a23.707,23.707,0,0,1,6.533-4.659,38.362,38.362,0,0,1,4.046-1.7c1.2-.285,1.923-2.73,2.254-4.316.308-1.479,1.172-4.7-.1-4.7-1.158,0-1.608,1.191-1.783,2.117a15.413,15.413,0,0,1-.794,2.8l-.07.178-3.209.968",
    transform: "translate(-514.464 -535.946)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M265.876,314.063c1.731-2.671,6.819-4.164,6.819-4.164a17.131,17.131,0,0,1,3.76-1.857c.793-.183,2.119.9.983,1.915-.6.531-1.943,1.756-1.943,1.756l3.209-.968.07-.178a15.411,15.411,0,0,0,.794-2.8c.175-.926.625-2.117,1.783-2.116.347,0,.534.24.618.618a8.288,8.288,0,0,0,.388-2.754h0c0-.094.007-.189.007-.284a7.244,7.244,0,0,0-7.2-7.134,7.411,7.411,0,0,0-6.546,4.256h0a7.411,7.411,0,0,0-6.546-4.256,7.244,7.244,0,0,0-7.2,7.134c0,.1,0,.19.007.284h0s-.406,4.54,4.646,9.5c1.89,1.894,3.966,3.711,7,6.21C265.423,317.943,264.556,316.1,265.876,314.063Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin12);
export default __webpack_public_path__ + "static/media/spin12.4400126ab4cf6a55fe63707aa406c7e5.svg";
export { ForwardRef as ReactComponent };